"use strict";

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var components_1 = require("@lsg/components");

var RoundPicture_1 = require("../RoundPicture/RoundPicture");

exports.Person = function (data) {
  var name = data.name,
      position = data.position,
      avatar = data.avatar;
  return react_1["default"].createElement(exports.PersonWrapper, null, react_1["default"].createElement(exports.PersonAvatar, null, react_1["default"].createElement(RoundPicture_1.RoundPicture, {
    asBackgroundImage: true,
    fluidData: avatar.fluid({
      aspectRatio: '1:1'
    })
  })), react_1["default"].createElement(Container, null, react_1["default"].createElement(components_1.Paragraph, {
    noMargin: true
  }, react_1["default"].createElement("strong", null, name)), react_1["default"].createElement(components_1.Paragraph, {
    size: components_1.Paragraph.Sizes && components_1.Paragraph.Sizes.HELPER,
    noMargin: true
  }, position)));
};

exports.PersonWrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
exports.PersonAvatar = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 50px;\n  padding-right: 24px;\n\n  @media (min-width: 1024px) {\n    width: 60px;\n  }\n"], ["\n  width: 50px;\n  padding-right: 24px;\n\n  @media (min-width: 1024px) {\n    width: 60px;\n  }\n"])));
var Container = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2, templateObject_3;